import { useState, useEffect } from "react";
import { 
  Dot,
  ChevronDown,
  ChevronUp,
} from "lucide-react";

export default function MessageThinkingFeed({ messageLoading, thinkingFeed }) {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    setIsOpen(false);
  }, [messageLoading]);

  if (!messageLoading) return null;
  
  return (
    <div className="flex flex-col mb-5 gap-2 text-base text-stone-600 bg-white rounded-lg shadow-sm px-4 py-2" 
      style={{ maxWidth: "85%" }}
    >
      <div className="flex items-center justify-between font-semibold cursor-pointer"
        onClick={() => {
          setIsOpen(!isOpen);
        }}
      >
        <div className="flex items-center">
          <Dot 
            size={28} className="animate-ping" 
          /> 
          <span>Thinking…</span>
        </div>
        {isOpen ? <ChevronUp size={28} className="text-stone-500" /> : <ChevronDown size={28} className="text-stone-500" />}
      </div>

      <div 
        
        className={`ml-2 flex flex-col items-start gap-2 font-medium ${
          isOpen ? "block" : "hidden"
        } transition-all duration-300 ease-in-out overflow-hidden`}
      >
        {thinkingFeed.length === 0 ? (
          <div className="flex flex-col items-start gap-2 border-t border-stone-100 pt-2">
            Starting to work...
          </div>
        ) : (
          thinkingFeed.slice(-5).map((thought, i) => (
            <div key={i} className="flex flex-col items-start gap-2 border-t border-stone-100 pt-2">
              <div>
                {thought.text}
              </div>
              {thought.argsPreview ? (
                <div className="text-xs opacity-70 break-words">{thought.argsPreview}</div>
              ) : null}
            </div>
          ))
        )}
      </div>
    </div>  
  );
};